import loggerService from '@/services/logger.service';

export function getTruncatedText(text: string, charLimit: number, showEllipsis: boolean): string {
  if (!text) {
    return '';
  }

  if (text.length <= charLimit) {
    return text;
  }

  if (showEllipsis) {
    return text.substring(0, charLimit) + '...';
  }

  return text.substring(0, charLimit);
}

export function stripChatInputText(text: string) {
  try {
    const passedTextStrippedOfBr = (text || '').replace(/<br\/?>/g, '\n');
    const strippedText = new DOMParser().parseFromString(passedTextStrippedOfBr, 'text/html');
    if (strippedText.getElementsByTagName('parsererror').length > 0) {
      throw new Error('Error parsing users messsage as html! Continuing as string!');
    }
    return strippedText.body.textContent || '';
  } catch (err) {
    loggerService.warn("Error parsing user's message", { error: err });
    return text || '';
  }
}

export function getCapitalizeText(text: String) {
  try {
    return text[0].toUpperCase() + text.substring(1);
  } catch (error) {
    loggerService.warn('Error while capitalizing text!!', error);
    return text || '';
  }
}
